import styled from 'styled-components'

export const Container = styled.div`
  background: transparent;

  @media (max-width: 1279px) {
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 25px;
    max-width: 350px;
  }

  @media (max-width: 999px) {
    max-width: 290px;
  }

  @media (max-width: 767px) {
    max-width: unset;
  }
`

export const Link = styled.a`
  color: #3a64f8;
`
